import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
const includedItems = [{
  title: 'KIT +300 MAPAS MENTALES A1-C2',
  value: '$19990'
}, {
  title: '3 Bonos Exclusivos',
  value: '$37000'
}];
export function OfferSection() {
  return <section id="oferta" aria-labelledby="oferta-title" className="bg-cream" data-id="element-135" data-mp="8mn7clhdiy2g">
      <div className="mx-auto max-w-2xl px-5 py-20 lg:py-24" style={{
      backgroundColor: "#FFFFFF",
      backgroundImage: "none"
    }} data-id="element-136" data-mp="def114vttjwt">
        <h2 id="oferta-title" className="text-center font-display text-3xl font-black leading-[1.1] text-ink sm:text-4xl" data-id="element-137" data-mp="icorj26lvwc3">
          <span aria-hidden="true" data-id="element-138" data-mp="mgo6hgc8mn3c">🏆 </span>Oferta especial de lanzamiento
        </h2>

        <div className="relative mt-12 rounded-3xl border border-coral px-4 pb-8 pt-12 sm:px-10 sm:pb-9" data-id="element-139" data-mp="rbtrmcxtfxqd">
          <span className="absolute -top-[0.85rem] left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-coral px-4 py-1.5 text-[11px] font-bold uppercase tracking-[0.14em] text-cream" data-id="element-140" data-mp="wawubqqbprv6">
            Kit +300 mapas mentales
          </span>

          <ul className="divide-y divide-line" data-id="element-141" data-mp="12ns0v29366w0">
            {includedItems.map(item => <li key={item.title} className="flex items-baseline justify-between gap-3 py-5 sm:gap-6" data-id="element-142" data-mp="xx1yzyzvcm62">
                <span className="text-[13px] leading-snug text-muted sm:text-sm" data-id="element-143" data-mp="sxfingoqupt1">{item.title}</span>
                <span className="shrink-0 text-sm font-semibold text-coral" data-id="element-144" data-mp="ownbcszfmuze">{item.value}</span>
              </li>)}
            <li className="flex items-baseline justify-between gap-3 border-t border-line py-5 sm:gap-6" data-id="element-145" data-mp="1lmmkaojhvvii">
              <span className="text-[13px] font-bold uppercase tracking-[0.08em] text-ink sm:text-sm" data-id="element-146" data-mp="1gocm052h4eso">Valor total:</span>
              <span className="shrink-0 text-sm font-semibold text-coral line-through" data-id="element-147" data-mp="1ck4ww6s3swtx">$56990</span>
            </li>
          </ul>

          <div className="flex flex-col items-center gap-3 pt-8 text-center" data-id="element-148" data-mp="17oxv54iea27n">
            <span className="text-[11px] font-bold uppercase tracking-[0.2em] text-coral" data-id="element-149" data-mp="17ucannik70k">Solo por hoy</span>
            <p className="font-display text-4xl font-black leading-none text-coral sm:text-6xl" data-id="element-150" data-mp="3sex3hf3cqdas">
              <span aria-hidden="true" data-id="element-151" data-mp="3trwr6tvcp14p">🏆 </span>$19990
            </p>
          </div>

          <p className="mt-8 border-t border-line pt-6 text-center text-xs text-muted" data-id="element-152" data-mp="2mx0jgeak6dg">
            <span aria-hidden="true" data-id="element-153" data-mp="3ksrttqvizdu4">💳 </span>Pago único, acceso de por vida. Sin suscripción.
          </p>

          <a href="https://mapa-mental-ingles.impultienda.ar/checkout" className="group mt-6 flex w-full items-center justify-center gap-2 rounded-full bg-coral px-5 py-4 text-center text-[12px] font-bold uppercase leading-tight tracking-[0.08em] text-cream sm:gap-3 sm:px-8 sm:py-5 sm:text-sm sm:tracking-[0.1em] shadow-cta transition-[transform,background-color] duration-150 ease-out-expo hover:-translate-y-0.5 hover:bg-coral-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-ink" data-id="element-154" data-mp="3ot3e32jz7c52">
            Consigue el Kit +300 Mapas Mentales
            <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-150 ease-out-expo group-hover:translate-x-1" aria-hidden="true" data-id="element-155" data-mp="2x37b993aaild" />
          </a>

          <p className="mt-6 text-center text-xs text-muted" data-id="element-156" data-mp="28jdrjcyqyk0t">
            Descarga instantánea · Pago único · Acceso de por vida · Garantía por 7 días
          </p>
        </div>
      </div>
    </section>;
}